import '@patternfly/react-core/dist/styles/base.css';
import '@hawtio/react/dist/index.css'; // Provides all of the css for JMX, Camels etc... plugins
import './index.css';
import('./bootstrap');
